"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveRow = void 0;
const lodash_1 = require("lodash");
const ot_1 = require("../../engine/ot");
const model_1 = require("../../model");
const store_1 = require("../../exports/store");
const set_records_1 = require("./set_records");
const i18n_1 = require("../../exports/i18n");
const types_1 = require("../../types");
const command_manager_1 = require("../../command_manager");
const commands_1 = require("../../commands");
const player_1 = require("../../modules/shared/player");
exports.moveRow = {
    undoable: true,
    execute: (context, options) => {
        const { model: state } = context;
        const { data, recordData, viewId } = options;
        const datasheetId = store_1.Selectors.getActiveDatasheetId(state);
        const snapshot = store_1.Selectors.getSnapshot(state, datasheetId);
        const recordMap = store_1.Selectors.getRowsIndexMap(state, datasheetId);
        if (!snapshot) {
            return null;
        }
        const views = snapshot.meta.views;
        if ((0, lodash_1.isEmpty)(data)) {
            return null;
        }
        if (!views.some(item => item.id === viewId)) {
            throw new Error((0, i18n_1.t)(i18n_1.Strings.error_move_row_failed_invalid_params));
        }
        const linkedActions = [];
        const actions = data.reduce((collected, recordOption) => {
            const { recordId, overTargetId: targetRecordId, direction } = recordOption;
            const originRowIndex = recordMap.get(recordId);
            const targetRowIndex = recordMap.get(targetRecordId);
            if (targetRowIndex == null || originRowIndex == null) {
                player_1.Player.doTrigger(player_1.Events.app_error_logger, {
                    error: new Error('There is a problem with the moved row record data'),
                    metaData: {
                        recordId,
                        targetRecordId,
                        targetRowIndex,
                        originRowIndex,
                        rowIndexMap: JSON.stringify(recordMap),
                        recordIds: JSON.stringify(Object.keys(snapshot.recordMap)),
                        rows: JSON.stringify(snapshot.meta.views[0].rows)
                    },
                });
                return collected;
            }
            let targetIndex = originRowIndex > targetRowIndex ? targetRowIndex + 1 : targetRowIndex;
            if (direction === store_1.DropDirectionType.BEFORE) {
                targetIndex--;
            }
            const action = model_1.DatasheetActions.moveRow2Action(snapshot, { recordId, target: targetIndex, viewId });
            if (!action) {
                return collected;
            }
            if (collected.length) {
                const transformedAction = ot_1.jot.transform([action], collected, 'right');
                collected.push(...transformedAction);
            }
            else {
                collected.push(action);
            }
            return collected;
        }, []);
        if (recordData) {
            const rst = set_records_1.setRecords.execute(context, {
                cmd: commands_1.CollaCommandName.SetRecords,
                data: recordData,
            });
            if (rst) {
                if (rst.result === command_manager_1.ExecuteResult.Fail) {
                    return rst;
                }
                actions.push(...rst.actions);
                linkedActions.push(...(rst.linkedActions || []));
            }
        }
        if (actions.length === 0) {
            return null;
        }
        return {
            result: command_manager_1.ExecuteResult.Success,
            resourceId: datasheetId,
            resourceType: types_1.ResourceType.Datasheet,
            actions,
            linkedActions,
        };
    },
};
//# sourceMappingURL=move_row.js.map